import { Shimmer } from '@components';

import {
  Container,
  Content,
  Header,
  Title,
  Line,
  Heading,
  Spacing,
  Divider,
  Buttons,
} from './DefaultFields.styles';

const ItemLoading = () => {
  return (
    <Line>
      <Shimmer
        style={{ height: 14, width: 120, borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{ height: 14, width: 300, borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <Shimmer
        style={{ height: 14, width: 140, borderRadius: 4 }}
        primary="#f1f1f1"
        secondary="#ececec"
      />
      <div />
    </Line>
  );
};

const TableContentLoading = () => {
  return (
    <>
      <Divider />
      <Content>
        <Spacing>
          <ItemLoading />
          <ItemLoading />
        </Spacing>
      </Content>
    </>
  );
};

const TableLoading = () => {
  return (
    <>
      <Spacing>
        <Heading>
          <Shimmer
            style={{ height: 12, width: 70, borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <Shimmer
            style={{ height: 12, width: 70, borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <Shimmer
            style={{ height: 12, width: 70, borderRadius: 4 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <div />
        </Heading>
      </Spacing>

      <TableContentLoading />
    </>
  );
};

const CustomStatusLoading = () => {
  return (
    <Container>
      <Header>
        <Title>Custom Status</Title>
        <Buttons>
          <Shimmer
            style={{ height: 36, width: 250, borderRadius: 8, marginRight: 8 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
          <Shimmer
            style={{ height: 36, width: 136, borderRadius: 8 }}
            primary="#f1f1f1"
            secondary="#ececec"
          />
        </Buttons>
      </Header>

      <TableLoading />
    </Container>
  );
};

export { CustomStatusLoading, TableLoading, TableContentLoading };
